import React from 'react';
import { SVGIconProps } from './props';

const UpdateSVGIcon = (props: SVGIconProps) => {
    return (
        <span className={props.className}>
            <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M2.34155 4.13521C3.39714 3.07962 4.74762 2.31598 6.2609 1.98196L6.15701 0L10.0678 2.06057L11.1124 2.61347L11.3062 2.715L10.9972 2.88067L9.53749 3.66646L6.4379 5.33436L6.3508 3.69488C5.26958 3.98354 4.30664 4.55672 3.53451 5.32591C2.38922 6.47116 1.68468 8.04642 1.68468 9.79293C1.68468 10.6883 1.86993 11.5365 2.20396 12.3056L0.659689 12.9763C0.236 12.0023 0.000132561 10.9245 0.000132561 9.79293C-0.00285149 7.58577 0.895518 5.58125 2.34155 4.13521Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
                <path
                    d='M6.46008 15.9191L9.56242 14.2508L9.64933 15.8907C10.7304 15.6017 11.6962 15.0289 12.4654 14.2598C13.6109 13.1141 14.3155 11.5392 14.3155 9.79309C14.3155 8.89694 14.1302 8.05174 13.7962 7.27999L15.3404 6.60938C15.7641 7.58597 16 8.66443 16 9.79309C16 11.9995 15.1046 14.0069 13.6585 15.4504C12.603 16.506 11.2525 17.2693 9.73942 17.6003L9.84331 19.5856L5.93506 17.5246L4.88482 16.9717L4.69402 16.8706L5 16.7049L6.46008 15.9191Z'
                    fill={props.front_fill ?? '#789DD8'}
                />
            </svg>
        </span>
    );
};

export default UpdateSVGIcon;
